import { queryOptions } from '@tanstack/react-query';
import type { ApiClient } from '@/lib/api';

export function scriptsListQueryKey(selectedOrgId: string | null) {
  return ['scripts', 'list', selectedOrgId] as const;
}

export function scriptsListOptions(apiClient: ApiClient, selectedOrgId: string | null) {
  return queryOptions({
    queryKey: scriptsListQueryKey(selectedOrgId),
    enabled: !!selectedOrgId,
    staleTime: 5 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const response = await apiClient.scripts.getScripts();
      return response.data ?? [];
    },
  });
}
